import { useState } from 'react';

import { useEventListQuery } from '../../../../../../../../hooks/queries/event/useEventList';
import { setDateFormat } from '../../../../../../../../lib/moment';
import { SearchEventItemType, SearchOptionType } from './types';
import { EVENT_STATUS, EVENT_STATUS_TEXT } from '../../../../../../../../constants/service/app/eventConstants';
import { DATE_FORMAT } from '../../../../../../../../constants/service/common/utilConstants';
import { INITIAL_OPTION } from './SearchEventListModalContainer';

type ResponseEventList = {
  totalCount: number;
  events: SearchEventItemType[];
};
export const useSearchEventListModalViewModel = () => {
  const [selectedIdList, setSelectedIdList] = useState<number[]>([]);
  const [option, setOption] = useState<SearchOptionType>(INITIAL_OPTION);
  /**
   * status 는 서버에서 active, inactive, unlimited 로 받고 보내주고 있지만
   * 기존에 index 로 사용하고 있어 서버에서 주고 받을때 형태를 변형해줌
   * 뷰에서는 기존과 동일하게 index 형태로 사용
   */
  const { data }: { data?: ResponseEventList } = useEventListQuery({
    payload: {
      page: option.pagination.pageNum,
      pageSize: option.pagination.pageSize,
      id: option.filterOption.id,
      status: (Object.keys(EVENT_STATUS) as Array<keyof typeof EVENT_STATUS>).find(
        (key) => EVENT_STATUS[key] === option.filterOption.status,
      ),
      mainTitle: option.filterOption.mainTitle,
    },
    options: {
      select: ({ totalCount, events }) => ({
        totalCount,
        events: events.map((event) => {
          const status = EVENT_STATUS[event.status] as keyof typeof EVENT_STATUS_TEXT;
          return {
            id: event.id,
            status,
            mainTitle: event.mainTitle,
            period:
              status === EVENT_STATUS.unlimited
                ? EVENT_STATUS_TEXT[EVENT_STATUS.unlimited]
                : `${setDateFormat(event.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} ~ ${setDateFormat(
                    event.endDate,
                    DATE_FORMAT.FULL_DASH_FORMAT,
                  )}`,
          };
        }),
      }),
    },
  });

  const dispatchOption = (option: SearchOptionType) => {
    setOption(option);
  };

  const handleCheck = (idList: number[], id: number | null) => {
    const selectedId = id || idList[0];
    setSelectedIdList([selectedId]);
  };

  return {
    eventList: data?.events || [],
    totalCount: data?.totalCount || 0,
    selectedIdList: selectedIdList,
    option: option,
    dispatchOption: dispatchOption,
    onCheck: handleCheck,
  };
};
